// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".large-h-log[data-v-3c8934a5]{height:calc(100vh - 10rem)}.small-h-log[data-v-3c8934a5]{height:40rem}.min-h-layout[data-v-3c8934a5]{min-height:42rem}", ""]);
// Exports
module.exports = exports;
